import {SidebarReleases as ReleasesComponent} from '@github-ui/code-view-sidebar/components/SidebarReleases'
import type {SidebarReleasesResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarReleases({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'releases', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/releases`)
      if (!r.ok) throw new Error(`Sidebar releases fetch failed (${r.status})`)
      return (await r.json()) as SidebarReleasesResponse
    },
  })

  if (!data) return null
  return <ReleasesComponent {...data} />
}
